module.exports = __webpack_public_path__ + "static/market.5b343ec0.jpg";